import { userStore, type Toast } from "../store";

export const addNotification = (toast: Toast) => {
  if (!toast.id) {
    throw new Error("Toast must have an id");
  }

  // Check if a toast with this ID already exists
  const existingToast = userStore.user.toast_notifications.find((notification) => notification.id === toast.id);

  // If toast already exists, don't add it again
  if (existingToast) {
    return toast.id;
  }

  // Create a new toast and add it to the array
  const newToast = { ...toast };
  userStore.user.toast_notifications.push(newToast);

  return toast.id;
};

type showNotification = {
  id: string;
  title: string;
  description?: string;
  duration?: number;
};

// Helper functions
export const showSuccess = ({ id, title, description, duration = 3000 }: showNotification) =>
  addNotification({ id, title, description, type: "success", duration });

export const showError = ({ id, title, description, duration = 5000 }: showNotification) =>
  addNotification({ id, title, description, type: "error", duration });

export const showInfo = ({ id, title, description, duration = 3000 }: showNotification) =>
  addNotification({ id, title, description, type: "info", duration });

export const showWarning = ({ id, title, description, duration = 4000 }: showNotification) =>
  addNotification({ id, title, description, type: "warning", duration });
